import {version} from "../../package.json"
export default {
  computed: {
    version() {
      return version;
    }
  },

}
